import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivableComment.Save.IRequest;
type Response = Api.Finance.AccountReceivableComment.Save.IResponse;
type Headers = Api.Finance.AccountReceivableComment.Save.IHeaders;
const url = '/api/Finance/AccountReceivableComment';
export default async function accountReceivableCommentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}

